import type { CaseType } from "./deriveCaseType";

interface AccessioningDisplayCaseNumberInput {
  authoritativeCaseNumber: string | null;
  caseType: CaseType;
  casePrefix?: string | null;
  externalCaseNumber?: string;
}

const CANONICAL_EXTERNAL_CASE_NUMBER_PREFIXES = new Set([
  "G",
  "GC",
  "HM",
  "HE",
]);

export function shouldUseExternalCaseNumberAsCanonical(
  caseType: CaseType,
  casePrefix?: string | null,
  externalCaseNumber?: string
): boolean {
  if (!externalCaseNumber?.trim()) return false;
  if (caseType === "pass_through") return true;
  return CANONICAL_EXTERNAL_CASE_NUMBER_PREFIXES.has(
    casePrefix?.trim().toUpperCase() ?? ""
  );
}

export function requiresCanonicalExternalCaseNumberBeforeDraftPrinting(
  caseType: CaseType,
  casePrefix?: string | null
): boolean {
  return (
    caseType === "pass_through" ||
    CANONICAL_EXTERNAL_CASE_NUMBER_PREFIXES.has(
      casePrefix?.trim().toUpperCase() ?? ""
    )
  );
}

export function getAccessioningDisplayCaseNumber({
  authoritativeCaseNumber,
  caseType,
  casePrefix,
  externalCaseNumber,
}: AccessioningDisplayCaseNumberInput): string | null {
  const normalizedExternalNumber = externalCaseNumber?.trim().toUpperCase();
  if (
    normalizedExternalNumber &&
    shouldUseExternalCaseNumberAsCanonical(
      caseType,
      casePrefix,
      normalizedExternalNumber
    )
  ) {
    return normalizedExternalNumber;
  }
  return authoritativeCaseNumber;
}

export function isDisplayedCaseNumberBackfill(
  displayedCaseNumber: string | null,
  backfillCaseNumber: string | null
): boolean {
  return (
    displayedCaseNumber !== null &&
    backfillCaseNumber !== null &&
    displayedCaseNumber === backfillCaseNumber
  );
}

export function shouldRequestPrefixAssignment(
  assignedPrefix: string | null,
  requestedPrefix: string | null,
  nextPrefix: string
): boolean {
  if (requestedPrefix) return requestedPrefix !== nextPrefix;
  return assignedPrefix !== nextPrefix;
}
